module.exports = __webpack_public_path__ + "static/Logo-6a3e41f834dfb5b6e3016c8234c5db1d.svg";